import React from 'react';
import LegalLayout from '../../components/LegalLayout';
import { ENTREPRISE as E, HORAIRES_PHRASE } from '../../data/entreprise';

const CGV = () => (
  <LegalLayout
    titre="Conditions générales de vente"
    description="Conditions générales de vente et de prestation de Suro Phone : devis, réparation iPhone et Samsung, garantie 3 mois, accessoires, intervention à domicile dans la Loire."
    path="/cgv"
  >
    <h2>1. Objet</h2>
    <p>
      Les présentes conditions générales régissent les prestations de réparation de smartphones (iPhone, Samsung et autres marques), les interventions à domicile et la vente d'accessoires proposées par {E.nom} ({E.formeJuridique}, SIRET {E.siret}), {E.adresse}. Toute commande ou prise de rendez-vous implique l'acceptation sans réserve des présentes.
    </p>

    <h2>2. Devis et prix</h2>
    <p>
      Tout devis est gratuit et sans engagement. Il est communiqué par téléphone, WhatsApp ou à l'atelier après description de la panne, puis confirmé après diagnostic de l'appareil. Aucune réparation n'est engagée sans l'accord du client. Les prix sont exprimés en euros TTC.
      En cas de panne supplémentaire découverte lors du diagnostic, un nouveau devis est soumis au client avant toute intervention.
    </p>

    <h2>3. Rendez-vous et horaires</h2>
    <p>
      L'atelier reçoit sur rendez-vous uniquement, {HORAIRES_PHRASE}. Les interventions à domicile dans la Loire (42) sont planifiées d'un commun accord ; des frais de déplacement peuvent s'appliquer selon la distance et sont précisés dans le devis.
    </p>

    <h2>4. Pièces et exécution</h2>
    <p>
      Les pièces utilisées sont des pièces premium testées, neuves, compatibles ou d'origine selon le choix du client indiqué au devis. La plupart des réparations sont réalisées le jour même ; un délai supplémentaire peut être nécessaire en cas d'indisponibilité d'une pièce, le client en est alors informé.
    </p>

    <h2>5. Données et sauvegarde</h2>
    <p>
      Le client est invité à sauvegarder ses données avant toute intervention et à désactiver les verrouillages (code, « Localiser », compte Google) nécessaires au diagnostic. {E.nom} ne saurait être tenu responsable d'une perte de données consécutive à une panne ou à une réparation.
    </p>

    <h2>6. Garantie</h2>
    <p>
      Les réparations sont garanties <strong>3 mois</strong> à compter de la date d'intervention, pièces et main-d'œuvre, sur la pièce remplacée et le défaut constaté. Sont exclus : casse, chute, oxydation, choc, pression, usure normale, intervention d'un tiers, et tout dommage non lié à la réparation effectuée. La garantie légale de conformité s'applique aux accessoires vendus.
    </p>

    <h2>7. Paiement</h2>
    <p>
      Le paiement s'effectue à la restitution de l'appareil ou à la fin de l'intervention à domicile, en espèces ou par les moyens indiqués à l'atelier. Une facture est remise sur demande.
    </p>

    <h2>8. Appareils non récupérés</h2>
    <p>
      Tout appareil non récupéré dans un délai de 3 mois après notification au client est réputé abandonné, conformément à la législation en vigueur.
    </p>

    <h2>9. Droit de rétractation</h2>
    <p>
      Conformément à l'article L.221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux prestations de réparation pleinement exécutées avec l'accord du client, ni aux interventions urgentes à domicile demandées par le client.
    </p>

    <h2>10. Litiges</h2>
    <p>
      Les présentes conditions sont soumises au droit français. En cas de litige, une solution amiable sera recherchée en priorité ; le client peut recourir gratuitement à un médiateur de la consommation. À défaut, les tribunaux compétents sont ceux du ressort de Saint-Étienne.
    </p>
  </LegalLayout>
);

export default CGV;
